<template>
  <div class="login-config">
    <div class="config-title">
      <h3>登录配置</h3>
    </div>
    <el-form class="config-form" ref="form" :model="form" label-width="170px" label-position="left">
      <el-form-item label="系统登录方式">
        <el-checkbox-group class="el-checkbox-all" v-model="form.systemLoginTypes">
          <el-checkbox :label="1">微信登录</el-checkbox>
          <el-checkbox :label="2">密码登录</el-checkbox>
        </el-checkbox-group>
        <span class="tip">说明：自定义首系统登录方式，不选择，系统将不登录进行使用</span>
      </el-form-item>
      <el-form-item label="设置工具使用是否登录" v-show="form.systemLoginTypes.length>0">
        <el-switch v-model="form.toolNeedLogin"></el-switch>
        <span class="tip">说明：设置工具使用是否需要登录，开启后，需要添加工具，没有添加的工具，用户使用将不需要登录</span>
      </el-form-item>
      <el-form-item class="config-table" v-if="form.systemLoginTypes.length>0&&form.toolNeedLogin">
        <div class="form-table">
          <span class="login-tools">请添加哪些工具需要登录</span>
          <el-table
              border
              :data="form.needLoginTools"
              height="350"
              :highlight-current-row="false"
              style="width: 100%">
              <el-table-column
                type="index"
                label="序号"
                align="center"
                width="50">
              </el-table-column>
              <el-table-column label="工具名称" align="center">
                <template slot-scope="scope">
                  <el-form-item
                    :prop="'needLoginTools.' + scope.$index + '.toolName'"
                    :rules="rules['toolName']">
                    <el-select
                    v-model="scope.row.toolName"
                    collapse-tags
                    size="small"
                    clearable 
                    filterable
                    
                    @change="changeCurrent($event,scope.$index)"
                    style="margin-left: 20px;"
                    placeholder="请选择">
                    <el-option
                      v-for="item in toolsOptions"
                      :key="item.id"
                      :disabled="item.flag" 
                      :label="item.name"
                      :value="item.name">
                      {{ item.name }}
                    </el-option>
                  </el-select>
                  </el-form-item>
                </template> 
              </el-table-column>
              <el-table-column
                prop="index"
                label="配置登录节点"
                align="center"
                >
                <template slot-scope="scope">
                  <el-radio-group v-model="scope.row.loginType">
                  <el-radio :label="0">上传页面登录</el-radio>
                  <el-radio :label="1">工具执行登录</el-radio>
                  <el-radio :label="2">文件下载登录</el-radio>
                </el-radio-group>
                </template>
              </el-table-column>
              <el-table-column
                label="操作"
                align="center"
                width="100"
                >
                <template slot-scope="scope">
                  <el-button style="color:#f56c6c ;" type="text" @click="delToolsSetLogin(scope.$index)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          <div class="btn"> <el-button size="small" icon="el-icon-plus" type="primary" @click="addToolsSetLogin">添加</el-button></div>
        </div>
      </el-form-item>
      <el-form-item label="网盘功能" v-show="form.systemLoginTypes.length>0" >
        <el-switch v-model="form.openNetDisk"></el-switch>
        <span class="tip">说明：开启后，云盘上传文件功能、批量/保存云文档功能、我的文档功能，将会显示</span>
      </el-form-item>
      <el-form-item class="config-btn">
        <el-button size="small" type="primary" @click="saveLoginType">保存</el-button>
        <el-button  size="small" @click="cancel">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import {toolUploadAPI,toolsAPI} from 'liankong-ui-api'  
export default {
  components: {},
  data() {
    return {
      form:{
        systemLoginTypes:[],
        toolNeedLogin:false,
        openNetDisk:false,
        needLoginTools:[{id:'1',loginType:0,toolName:''}]
      },
      rules:{
        toolName:[{required:true,message:'请选择工具名称',trigger:'change'}]
      },
      toolsOptions:[],
      restData:null
    };
  },
  computed: {},
  mounted(){
    this.getToolsList()  // 工具列表
    this.getDetail()  // 获取系统登录配置
    
  },
  methods: {
    getDetail(){
        toolUploadAPI.getSystemLoginConfig().then(res=>{
        if(res.code==0){
          const loginData=res.data
          this.restData = res.data
          this.form.systemLoginTypes=loginData.systemLoginTypes
          this.form.toolNeedLogin=loginData.toolNeedLogin
          this.form.openNetDisk=loginData.openNetDisk
          this.form.needLoginTools=loginData.needLoginTools.length>0?loginData.needLoginTools:[{id:'1',loginType:0,toolName:''}]
        console.log(this.form)
        } else {
          this.$message.error(res.message)
        }
      })
    },
    getToolsList(){
      toolsAPI.getAllToolsList().then(res=>{
        if(res.code==0){
          this.toolsOptions = res.data.map(item=>{
            return {
              ...item,
              flag:false
            }
          })
        }
        else {
          this.$message.error(res.message)
        }
      })
    },
    // 取消
    cancel(){
      this.form = this.restData
    },
    // 保存
    saveLoginType(){
      this.$refs.form.validate(valid=>{
        if(valid){
          toolUploadAPI.updateSystemConfigLogin(this.form).then(res=>{
            if(res.code==0){
              this.$ebus.$emit('updateLeft')
              this.$message.success('保存成功')
            } else {
              this.$message.error(res.message)
            }
          })
        } else {
          return false
        }
      })
    },
    // selec改变
    changeCurrent(item,index){
      // 空的时候给id和toolName空
      if(item==''){
        this.form.needLoginTools[index].id=''
        this.form.needLoginTools[index].toolName = ''
      } else {
        this.form.needLoginTools[index].id= this.toolsOptions.find(i=>i.name===item).id
      }
      // 获取所有选择的数据
     const toolsLogin = this.form.needLoginTools.map(item=>item.toolName)
     // 重置选择状态
     this.toolsOptions.forEach(item=>item.flag = false)
     // 设置选择状态
     toolsLogin.forEach(item=>{
      const toolsOptionsFindIndex = this.toolsOptions.findIndex(i=>i.name===item)
      this.toolsOptions[toolsOptionsFindIndex].flag = true
     })
    },
    // 表格添加
    addToolsSetLogin(){
      this.form.needLoginTools.push({
        id:'',
        loginType:0,
        toolName:''
      })
    },
    // 表格删除
    delToolsSetLogin(index){
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.form.needLoginTools.splice(index,1)
        })
    }
  },

 
};
</script>

<style lang='less' scoped>
.login-config {
  padding: 20px;
  box-sizing: border-box;
  min-height: 95vh;
  .config-title {
    h3 {
      margin: 0px;
      padding: 0px;
      position: relative;
      &::before {
        content: '';
        width: 5px;
        height: 20px;
        background: #409EFF;
        position: absolute;
        left: 0px;
        top: 0px;
      }
      padding-left: 15px;
    }
  }
  .config-form {
    padding: 20px;
    box-sizing: border-box;
    .el-form-item {
      margin-bottom: 5px;
      .el-checkbox-all {
        display: inline-flex;
      }
    }
  }
  .config-table {
    /deep/ .el-form-item__content {
      margin-left: 0px !important;
    }
    .form-table {
      border:1px solid rgba(228, 228, 228, 1);
      padding: 10px;
      box-sizing: border-box;
      .login-tools {
        color: #333;
        font-weight: 400;
        font-size: 14px;
      }
      /deep/ .el-form-item__error {
        position:relative;
        left:-10%;
      }
      /deep/ .el-table__cell {
        padding: 4px 0;
      }
      /deep/ .has-gutter {

        tr {
          th {
            color: #333;
            background: #e4e4e4;
          }
        }
      }
      /deep/ .el-table__body tr:hover{
        td.el-table__cell {
          background: #fff;
        }
      }
      .btn {
        margin-top: 15px;
        width: 100%;
        display: flex;
        justify-content: center;
      }
    }
   
    // margin-left: 0px;
  }
  .config-btn {
    display: flex;
    justify-content: center;
    /deep/ .el-form-item__content {
      margin-left: 0px !important;
    }
  }
}
.tip {
  color: #AEAEAE;
  font-size: 12px;
  margin-left: 2vw;
}
</style>